import styled from 'styled-components';
import { UnstyledButton } from '../../../basics/UnstyledButton';
import { NoteIcon } from '../../../icons/NoteIcon';
import { HoverNavItem, NameInput } from '../../../left-menu/menu-components';
import { useNotesContext } from '../../../../contexts/NotesContext';

const Title = styled(NameInput)`
  margin-left: 12px;
  align-items: center;
  align-content: center;
`;

const NoteContainer = styled(HoverNavItem)`
  ${({ isActive }) => isActive && `background-color: var(--active-secondary)`};
`;

export const Note = ({ title, id, onClick, selected }) => {
  const { updateNoteTitle } = useNotesContext();

  return (
    <UnstyledButton onClick={onClick} className="text-left w-100" id={id}>
      <NoteContainer isActive={selected}>
        <NoteIcon />
        <Title name={title} update={(value) => updateNoteTitle(id, value)} />
      </NoteContainer>
    </UnstyledButton>
  );
};
